import { zodMoment } from '@qapline/helpers';
import { z } from 'zod';

import { extendedDispatcherSchema } from './dispatcher';

export const carrierSchema = z.object({
    carrier_id: z.number(),
    company: z.string(),
    companyRegistrationNumber: z.string().nullable(),
    profilePicture: z.string().nullable(),
    taxId: z.string().nullable(),
    street: z.string().nullable(),
    city: z.string().nullable(),
    countryCode: z.string().nullable(),
    postalCode: z.string().nullable(),
    longitude: z.coerce.number().nullable(),
    latitude: z.coerce.number().nullable(),
    note: z.string().nullable(),
    number: z.number().nullable(),
    tsEdited: zodMoment().nullable(),
    tsAdded: zodMoment().nullable(),
    deleted: z.boolean().default(false),
    editedBy_id: z.number().nullable(),
    addedBy_id: z.number().nullable(),
});
export type TCarrier = z.infer<typeof carrierSchema>;

export const carrierExtendedSchema = carrierSchema.extend({
    dispatchers: extendedDispatcherSchema.array(),
});
export type TCarrierExtended = z.infer<typeof carrierExtendedSchema>;

export const carrierListItemSchema = z.object({
    carrier_id: z.number(),
    company: z.string(),
    companyRegistrationNumber: z.string().nullable(),
});
export type TCarrierListItem = z.infer<typeof carrierListItemSchema>;

export const customerCarrierListItemSchema = z.object({
    carrier_id: z.number(),
    number: z.number().nullable(),
    company: z.string(),
    companyRegistrationNumber: z.string().nullable(),
    country: z.string().nullable(),
    countryCode: z.string().nullable(),
    postalCode: z.string().nullable(),
    city: z.string().nullable(),
    lastCommissionDate: zodMoment().nullable(),
});
export type TCustomerCarrierListItem = z.infer<typeof customerCarrierListItemSchema>;

export const customerCarrierDetailSchema = z.object({
    carrier_id: z.number(),
    number: z.number().nullable(),
    company: z.string(),
    companyRegistrationNumber: z.string().nullable(),
    taxId: z.string().nullable(),
    profilePicture: z.string().nullable(),
    street: z.string().nullable(),
    city: z.string().nullable(),
    country: z.string().nullable(),
    countryCode: z.string().nullable(),
    postalCode: z.string().nullable(),
    email: z.string().nullable(),
    phone: z.string().nullable(),
    primaryContact: z
        .object({
            name: z.string(),
            surname: z.string(),
            email: z.string().nullable(),
            phone: z.string().nullable(),
            languageCode: z.string().nullable(),
        })
        .nullable(),
    metrics: z.object({
        totalCommissions: z.number().int().nonnegative(),
        activeCommissions: z.number().int().nonnegative(),
    }),
});
export type TCustomerCarrierDetail = z.infer<typeof customerCarrierDetailSchema>;
